import { render } from "./WellInfoTab.vue?vue&type=template&id=fd650a6e&scoped=true"
import script from "./WellInfoTab.vue?vue&type=script&lang=js"
export * from "./WellInfoTab.vue?vue&type=script&lang=js"

import "./WellInfoTab.vue?vue&type=style&index=0&id=fd650a6e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd650a6e"]])

export default __exports__